var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.375C12.75 10.9492 12.3672 11.4414 11.875 11.6328V13.4375H12.0938C12.4492 13.4375 12.75 13.7383 12.75 14.0938C12.75 14.4766 12.4492 14.75 12.0938 14.75H2.6875C1.45703 14.75 0.5 13.793 0.5 12.5625V2.9375C0.5 1.73438 1.45703 0.75 2.6875 0.75H11.4375C12.1484 0.75 12.75 1.35156 12.75 2.0625V10.375ZM10.5625 13.4375V11.6875H2.6875C2.19531 11.6875 1.8125 12.0977 1.8125 12.5625C1.8125 13.0547 2.19531 13.4375 2.6875 13.4375H10.5625ZM11.4375 10.375V2.0625H2.6875C2.19531 2.0625 1.8125 2.47266 1.8125 2.9375V10.5664C2.05859 10.457 2.35938 10.375 2.6875 10.375H11.4375ZM4.65625 5.125C4.27344 5.125 4 4.85156 4 4.46875C4 4.11328 4.27344 3.8125 4.65625 3.8125H9.46875C9.82422 3.8125 10.125 4.11328 10.125 4.46875C10.125 4.85156 9.82422 5.125 9.46875 5.125H4.65625ZM4.65625 7.3125C4.27344 7.3125 4 7.03906 4 6.65625C4 6.30078 4.27344 6 4.65625 6H9.46875C9.82422 6 10.125 6.30078 10.125 6.65625C10.125 7.03906 9.82422 7.3125 9.46875 7.3125H4.65625Z",
    fill: "#1D2132",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a9c666d2e226af88ff13158e22431a88.svg";
export { ForwardRef as ReactComponent };